import type { Locale } from "./domain";

export function money(millimes: number, locale: Locale) {
  return `${new Intl.NumberFormat(locale === "ar" ? "fr-TN" : "fr-TN", {
    minimumFractionDigits: 3,
    maximumFractionDigits: 3,
  }).format(millimes / 1_000)} ${locale === "ar" ? "د.ت" : "TND"}`;
}

export function shortDate(value: string, locale: Locale) {
  return new Intl.DateTimeFormat(locale === "ar" ? "ar-TN-u-nu-latn" : "fr-TN", {
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    month: "short",
  }).format(new Date(value));
}

export function distance(meters: number) {
  return meters < 1_000 ? `${Math.round(meters)} m` : `${(meters / 1_000).toFixed(1)} km`;
}
